import React, { useEffect, useState } from "react";
function AllUsersData() {
  const [users, setUsers] = useState([]);
  const [loading, setloading] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState(null);
  const [tempStatus, setTempStatus] = useState("Pending");
  const [updating, setUpdating] = useState(false);
  useEffect(() => {
    async function fetchUsers() {
      try {
        setloading(true);
        const res = await fetch(`https://procoor.com/api/employees`);
        const data = await res.json();
        setUsers(data.data);
      } catch (error) {
        console.log(error, "error");
      }
      setloading(false);
    }

    fetchUsers();
  }, []);

  const openStatusPopup = (userId, currentStatus) => {
    setSelectedUserId(userId);
    setTempStatus(currentStatus);
    setIsOpen(true);
  };
  const activateStatus = async () => {
    if (!selectedUserId) return;

    try {
      setUpdating(true);

      const response = await fetch(
        `https://procoor.com/api/employees/${selectedUserId}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ status: tempStatus }),
        }
      );

      if (response.ok) {
        setUsers((prevUsers) =>
          prevUsers.map((user) =>
            user.id === selectedUserId ? { ...user, status: tempStatus } : user
          )
        );
      } else {
        console.error("Failed to update status");
      }
    } catch (error) {
      console.error("Error updating status:", error);
    } finally {
      setUpdating(false);
      setIsOpen(false);
      setSelectedUserId(null);
    }
  };

  // const getSelectedUserName = () => {
  //   if (!selectedUserId) return "";
  //   const selectedUser = users.find((user) => user.id === selectedUserId);
  //   return selectedUser ? selectedUser.name : "";
  // };
  return (
    <>
      <main>
        <section
          className="contact contact_us_md  app-section Certificate"
          data-theme="dark"
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
          }}
        >
          <div className="container">
            <div
              className="row"
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <div
                className="col-lg-10"
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  flexDirection: "column",
                }}
              >
                {loading ? (
                  <div className="loading-container">
                    <div className="spinner"></div>
                    <div className="loading-text">loading</div>
                  </div>
                ) : (
                  <table>
                    <thead>
                      <tr>
                        <th>Name</th>
                        <th>Personal Email</th>
                        <th>Position</th>
                        <th>Account Name</th>
                        <th>Experience</th>
                        <th>Procoor Username</th>
                        <th>Company Name</th>
                        <th>Company Type</th>
                        <th>Module</th>
                        <th>status</th>
                      </tr>
                    </thead>
                    <tbody>
                      {users.map((user) => {
                        return (
                          <>
                            <tr
                              style={{ cursor: "pointer" }}
                              key={user.id}
                              onClick={() =>
                                openStatusPopup(user.id, user.status)
                              }
                            >
                              <td>{user.name}</td>
                              <td>{user.personalEmail}</td>
                              <td>{user.position}</td>
                              <td>{user.accountName}</td>
                              <td>{user.experience}</td>
                              <td>{user.procoorUsername}</td>
                              <td>{user.companyName}</td>
                              <td>{user.companyType}</td>
                              <td>{user.module}</td>
                              <td>
                                <div
                                  className="Status"
                                  style={{
                                    color:
                                      user.status === "Pending"
                                        ? "orange"
                                        : user.status === "Rejected"
                                        ? "red"
                                        : " green",
                                    fontWeight: "bold",
                                  }}
                                >
                                  {user.status}
                                  {updating && user.id === selectedUserId && (
                                    <span style={{ marginLeft: "5px" }}>
                                      Updating...
                                    </span>
                                  )}
                                </div>
                              </td>
                            </tr>
                          </>
                        );
                      })}
                    </tbody>
                  </table>
                )}

                {isOpen && (
                  <div className="popup-overlay">
                    <div className="popup-content">
                      <div style={{ display: "flex", gap: "5px" }}>
                        <h2>Change Status </h2>
                      </div>

                      <div className="status-options">
                        <label>
                          <input
                            type="radio"
                            value="Approved"
                            checked={tempStatus === "Approved"}
                            onChange={(e) => {
                              setTempStatus(e.target.value);
                            }}
                          />
                          Approved
                        </label>

                        <label>
                          <input
                            type="radio"
                            value="Rejected"
                            checked={tempStatus === "Rejected"}
                            onChange={(e) => {
                              setTempStatus(e.target.value);
                            }}
                          />
                          Rejected
                        </label>
                      </div>
                      <div className="popup-actions">
                        <button
                          onClick={() => {
                            setIsOpen(false);
                            setSelectedUserId(null);
                          }}
                          className="cancel-btn"
                        >
                          Cancel
                        </button>
                        <button
                          onClick={activateStatus}
                          className="confirm-btn"
                          disabled={updating}
                        >
                          {updating ? "Updating..." : "Confirm"}
                        </button>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </section>
      </main>
    </>
  );
}

export default AllUsersData;
